/**
 * Protected Route Component
 * Redirects to login if user is not authenticated
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';

const ProtectedRoute = ({ children, isAuthenticated, loading }) => {
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={process.env.PUBLIC_URL + "/sign-in"} replace />;
  }

  return children;
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth?.isAuthenticated || false,
  loading: state.auth?.loading || false,
});

export default connect(mapStateToProps)(ProtectedRoute);

